"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxObservable = require("redux-observable");

var _UpdateFormSettings = _interopRequireDefault(require("settings-ui-modules/marketing/modules/form/stagedObjects/UpdateFormSettings"));

var _epic = _interopRequireDefault(require("settings-ui-sdk/FormSettings/epic"));

var _default = (0, _reduxObservable.combineEpics)(_epic.default, _UpdateFormSettings.default.getResetChangesToStagedObjectEpic());

exports.default = _default;
module.exports = exports.default;